export const LOADING_STATE_IDLE = 0x0810;
export const LOADING_STATE_LOADING = 0x0811;
export const LOADING_STATE_ERROR = 0x0812;
export const LOADING_STATE_COMPLETE = 0x0813;

export const loadingStateEnum = {
    LOADING_STATE_IDLE,
    LOADING_STATE_LOADING,
    LOADING_STATE_ERROR,
    LOADING_STATE_COMPLETE,
};

export default {
    namespaced: true,
    state: {
        name: '初始化',
        currentState: LOADING_STATE_IDLE,
        error: null,
    },
    mutations: {
        mutate(state, payload) {
            Object.assign(state, payload);
        },
    },
    getters: {
        isIdle(state) {
            return LOADING_STATE_IDLE === state.currentState;
        },
        isLoading(state) {
            return LOADING_STATE_LOADING === state.currentState;
        },
        isError(state) {
            return LOADING_STATE_ERROR === state.currentState;
        },
        isComplete(state) {
            return LOADING_STATE_COMPLETE === state.currentState;
        },
    },
    actions: {
        reset({ commit }) {
            commit('mutate', {
                currentState: LOADING_STATE_IDLE,
            });
        },
        startLoading({ commit, getters, state }) {
            if (getters.isLoading) {
                throw new Error(
                    `"${state.name}" cannot start loading cause it's already in loading state`
                );
            }

            commit('mutate', {
                currentState: LOADING_STATE_LOADING,
            });
        },
        endLoading({ commit, getters, state }) {
            if (!getters.isLoading) {
                throw new Error(
                    `"${state.name}" cannot end loading cause it's not in loading state`
                );
            }

            commit('mutate', {
                currentState: LOADING_STATE_COMPLETE,
            });
        },
        encounterError({ commit, getters, state }, error) {
            if (!getters.isLoading) {
                throw new Error(
                    `"${state.name}" cannot accept an error cause it's not in loading state`
                );
            }

            if (!error) {
                throw new Error(
                    `"${state.name}" needs to meet an error object`
                );
            }

            commit('mutate', {
                error,
                currentState: LOADING_STATE_ERROR,
            });
        },
    },
};
